import React from 'react';

class PostFooter extends React.Component {
	render() {
		return null;
	}
}

export default PostFooter;
